import React from 'react';

export default function Contact() {
  return (
    <div>
      <div className='page'>
        <div className='contact_Container1'>
          <div className='box8'>
            <div class="pagetitle">Get in touch with ous</div>  
            <div class="discription">Ready to Transform Your Life? Our Team is Here to Guide You</div>        
          </div>
        </div>
        <div className="contact_Container2" >
          <div className="map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.296863266175!2d73.03037937580497!3d19.0065360541453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c34a226d3ee1%3A0x5527f5c728f4e683!2sPanada%20Fitness%20Centre!5e0!3m2!1sen!2sin!4v1764434404255!5m2!1sen!2sin" 
              width="100%" 
              height="490" 
              style={{ border: 0, borderRadius: '8px' }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Panada Fitness Centre Location"
            ></iframe>
          </div>
          <div className='box8'>
            <div className='card1'>
              <div class="icon-container"
                style={{
                  '--icon-url': "url('/images/route.png')",
                }}
              ></div>
              <div className='contact_details'>
                <div class="commentdiscription2">Address</div>
                <div class="commentdiscription2">Shop no. 12, Progressive Sea Lounge, 44, opposite Belapur Jetty, Sector 15</div>
              </div>
            </div>
            <div className='card1'>
              <div class="icon-container"
                style={{
                  '--icon-url': "url('/images/phone-call.png')",
                }}
              ></div>
              <div className='contact_details'>
                <div class="commentdiscription2">Phone</div>
                <div class="commentdiscription2">+91 90829 55754</div>
              </div>
            </div>
            <div className='card1'>
              <div class="icon-container"
                style={{
                  '--icon-url': "url('/images/email.png')",
                }}
              ></div>
              <div className='contact_details'>
                <div class="commentdiscription2">Mail</div>
                <div class="commentdiscription2">panada.fitness@gmail.com</div>
              </div>
            </div>
            <div className='card1'>
              <div class="icon-container"
                style={{
                  '--icon-url': "url('/images/route.png')",
                }}
              ></div>
              <div className='contact_details'>
                <div class="commentdiscription2">Address</div>
                <div class="commentdiscription2">Shop no. 12, Progressive Sea Lounge, 44, opposite Belapur Jetty, Sector 15</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}